
import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    IS_CHECKOUT,
    MARK_ATTENDANCE, OEM_MANUFACTURE_NAME, OPPORTUNITY, PENDING_ACTIVITY, SAVE_ACCOUNT,
    SAVE_ACTIVITY, SITE_POC_TYPE, ACCOUNT_FILTER,
    TYPES, LAST_CHECK_IN
} from "./type";



export const getActivity = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.CarServiceActivityType}?type=is_car_service`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: TYPES,
            payload: data.response,
        });
        return true;
    }
};

export const activitySave = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.carServiceActivitySave}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const markAttendance = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.carServiceAttendance}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: MARK_ATTENDANCE,
            payload: data.response,
        });
        return data.response;
    }
};

export const getPendingActivity = (accountId = '') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.carServicePendingActivity}?account_id=${accountId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: PENDING_ACTIVITY,
            payload: data.response,
        });
        return true;
    }
};

export const isCheckout = (type = 'Car Service', accountId='') => async (dispatch) => {
    if(accountId === "" || accountId === -1){
        return false
    }
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.carServiceIsCheckout}?type=${type}&account_id=${accountId}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: IS_CHECKOUT,
            payload: data.response,
        });
        return true;
    }
};

export const getOpportunity = (type) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.carServiceOpportunity}?type=${type}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: OPPORTUNITY,
            payload: data.response,
        });
        return true;
    }
};

export const saveAccount = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.carServiceAccount}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SAVE_ACCOUNT,
            payload: data.response,
        });
        return true;
    }
};

export const sitePocTypes = (type = 'is_car_service') => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.sitePocType}?type=${type}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_POC_TYPE,
            payload: data.response?.data,
        });
        return true;
    }
};

export const oemManufactureName = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.oemManufactureName}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: OEM_MANUFACTURE_NAME,
            payload: data.response?.data,
        });
        return true;
    }
};

export const accountFilter = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.carServiceAccountFilter}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: ACCOUNT_FILTER,
            payload: data.response,
        });
        return true;
    }
};

export const lastCheckIn = (moduleType) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.lastCheckIn}?module_type=${moduleType}`
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: LAST_CHECK_IN,
            payload: data.response?.data,
        });
        return true;
    }
};

